<script setup>
import { t } from "@/controllerLK/GlobusLocalization";
import { useRubricsStore } from "@/store/NewsFeed/rubrics";
import {useNewsFeedStore} from "@/store/NewsFeed/newsFeed";
import FavoriteEmptyIcon from "@/components/Icons/FavoriteEmptyIcon.vue";
import LocalLoader from "@/components/UI/LocalLoader.vue";

const rubricsStore = useRubricsStore();
const newsFeedStore = useNewsFeedStore();
</script>
<template>
  <div
    v-if="newsFeedStore.loading"
    class="newsfeed-empty__loader"
  >
    <LocalLoader />
  </div>
  <div v-else-if="newsFeedStore.favoriteVisible && newsFeedStore.totalCount === 0">
    <p
      class="newsfeed-empty br"
      :class="{'full-width': !rubricsStore.allRubrics.length}"
    >
      <span class="text-favorite">
        {{ t('news_page_body_empty_news.favorite_message') }}
        <FavoriteEmptyIcon />
        {{ t('news_page_body_empty_news.favorite_message_second') }}.
      </span>
    </p>
  </div>
  <div v-else>
    <p
      v-if="!rubricsStore.allRubrics.length"
      class="newsfeed-empty br full-width"
    >
      <span class="text_unfavorite">
        {{ t('news_page_body_empty_news.norubrics_message') }}
      </span>
    </p>

    <p
      v-else-if="rubricsStore.chosenRubrics.length === 0"
      class="newsfeed-empty br"
    >
      <span class="text_unfavorite">
        {{ t('news_page_body_empty_news.rubric_not_selected') }}
      </span>
    </p>
    <p
      v-else-if="newsFeedStore.totalCount <= 0"
      class="newsfeed-empty br"
    >
      {{ t('news_page_body_empty_news.message') }}
      <br>
      {{ t('news_page_body_empty_news.message_second') }}
    </p>
  </div>
</template>
<style lang="scss" scoped>
.newsfeed-empty {
  background: var(--background-bg-white);
  padding: 30px 20px;
  line-height: 140%;
  text-align: center;
  position: fixed;
  width: calc(100% - 285px);

  &__loader {
    width: 100%;
    height: calc(100% - 200px);
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
  }

  .text-favorite {
    display: block;
    font-size: 14px;
    font-weight: 400;
    width: 280px;
    line-height: 140%;
    color: #373D3F;
    justify-self: center;
  }


  &.full-width {
    width: calc(100% - 40px);

    display: flex;
    justify-content: center;
    align-items: center;

    .text_unfavorite {
      max-width: 280px;
      display: flex;
    }
  }
}
</style>
